'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var varint = require('varint');

var BufferList = require('bl/BufferList');

var POOL_SIZE = 10 * 1024;

var Encoder = /*#__PURE__*/function () {
  function Encoder() {
    _classCallCheck(this, Encoder);

    this._pool = new Uint8Array(POOL_SIZE);
    this._poolOffset = 0;
  }
  /**
   * Encodes the given message and returns it and its header
   *
   * @param {*} msg - The message object to encode
   * @returns {Uint8Array|Uint8Array[]}
   */


  _createClass(Encoder, [{
    key: "write",
    value: function write(msg) {
      var pool = this._pool;
      var offset = this._poolOffset;
      varint.encode(msg.id << 3 | msg.type, pool, offset);
      offset += varint.encode.bytes;
      varint.encode(msg.data ? msg.data.length : 0, pool, offset);
      offset += varint.encode.bytes;
      var header = pool.subarray(this._poolOffset, offset);

      if (POOL_SIZE - offset < 100) {
        this._pool = new Uint8Array(POOL_SIZE);
        this._poolOffset = 0;
      } else {
        this._poolOffset = offset;
      }

      if (!msg.data) return header;
      return [header, msg.data];
    }
  }]);

  return Encoder;
}();

var encoder = new Encoder(); // Encode one or more messages and yield a BufferList of encoded messages

module.exports = function (source) {
  return function () {
    var _encode = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, msg;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 2;
              _iterator = _asyncIterator(source);

            case 4:
              _context.next = 6;
              return _awaitAsyncGenerator(_iterator.next());

            case 6:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 18;
                break;
              }

              msg = _step.value;

              if (!Array.isArray(msg)) {
                _context.next = 13;
                break;
              }

              _context.next = 11;
              return new BufferList(msg.map(function (m) {
                return encoder.write(m);
              }));

            case 11:
              _context.next = 15;
              break;

            case 13:
              _context.next = 15;
              return new BufferList(encoder.write(msg));

            case 15:
              _iteratorAbruptCompletion = false;
              _context.next = 4;
              break;

            case 18:
              _context.next = 24;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](2);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 24:
              _context.prev = 24;
              _context.prev = 25;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 29;
                break;
              }

              _context.next = 29;
              return _awaitAsyncGenerator(_iterator.return());

            case 29:
              _context.prev = 29;

              if (!_didIteratorError) {
                _context.next = 32;
                break;
              }

              throw _iteratorError;

            case 32:
              return _context.finish(29);

            case 33:
              return _context.finish(24);

            case 34:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 20, 24, 34], [25,, 29, 33]]);
    }));

    function encode() {
      return _encode.apply(this, arguments);
    }

    return encode;
  }()();
};